import { createTheme, Theme, ThemeOptions } from '@mui/material'

export function getAppTheme (darkMode?: boolean): Theme {
  const lightTheme = {
    palette: {
      primary: {
        main: '#dc183d',
      },
      secondary: {
        main: '#001736',
      },
      background: {
        paper: '#ffffff',
        default: '#efefef',
      },
    },
    typography: {
      fontSize: 12,
    },
    overrides: {
      MuiAutocomplete: {
        option: {
          '&[data-focus="true"]': {
            color: '#dc183d',
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            border: '2px solid',
            borderColor: '#dc183d',
          },
          '&$focused $notchedOutline': {
            borderColor: '#dc183d',
            borderWidth: 1,
          },
        },
      },
      MuiTabs: {
        root: {
          backgroundColor: '#f5f5f5',
          borderTop: '2px solid',
          borderColor: '#ebe7e9',
        },
      },
      MuiTab: {
        root: {
          '&$selected': {
            backgroundColor: '#ffffff',
            borderTop: '3px solid',
            borderColor: '#dc183d',
            color: '#dc183d',
          },
        },
      },
      MuiButton: {
        root: {
          border: '1px solid #B72841',
          color: '#ffffff',
          backgroundColor: '#dc183d',
          minWidth: '0',
          boxShadow: 'none',
        },
        containedSecondary: {
          backgroundColor: '#ffffff',
          border: '1px solid #dc183d',
          color: '#FF3939',
          '&:hover': {
            backgroundColor: '#ffffff',
            border: '1px solid #dc183d',
            color: '#800000',
          },
        },
        containedPrimary: {
          color: '#ffffff',
          backgroundColor: '#dc183d',
          border: '1px solid #dc183d',
          '&:hover': {
            backgroundColor: '#ffffff',
            color: '1px solid #dc183d',
          },
        },
      },
      MuiPickersToolbarButton: {
        toolbarBtn: {
          border: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
          },
        },
      },
      MuiPickersToolbarText: {
        toolbarTxt: {
          '&:hover': {
            color: '#dc183d',
          },
        },
      },
    },
  }

  const darkTheme: ThemeOptions = {
    typography: {
      fontSize: 12,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            border: '1px solid #FF3939',
            minWidth: '0',
            boxShadow: 'none',
          },
          text: {
            color: '#dc183d',
          },
        },
      },
    },
    palette: {
      mode: 'dark',
      primary: {
        main: '#dc183d',
      },
      grey: {
        A100: 'transparent',
      },
      secondary: {
        main: '#dc183d',
      },
      background: {
        default: '#383838',
        paper: '#414141',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.5)',
        secondary: 'rgba(255, 255, 255, 0.3)',
      },
    },
  }

  const theme: Theme = createTheme(darkMode ? darkTheme : lightTheme)

  return theme
}
